import { defineComponent, inject, resolveComponent, openBlock, createElementBlock, normalizeClass, createBlock, createCommentVNode, createElementVNode, mergeProps } from 'vue';
import Label from '@ingka/label-vue';

var script = defineComponent({
    components: {
        Label
    },
    props: {
        id: {
            type: String,
            default: '',
            required: true
        },
        label: {
            type: String,
            default: 'Label'
        },
        placeholder: {
            type: String,
            default: undefined
        },
        req: {
            type: [String],
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        onChange: {
            type: Function,
            default: undefined
        },
        defaultValue: {
            type: [String, Number],
            default: undefined
        },
        value: {
            type: [String, Number],
            default: ''
        },
        prefix: {
            type: String,
            default: ''
        }
    },
    setup(props, { emit }) {
        var _a;
        const valid = inject('valid', true);
        const shouldValidate = inject('shouldValidate', false);
        const characterCount = inject('characterCount', null);
        const describedById = inject('validationMessageId', undefined);
        if (characterCount)
            characterCount.value = ((_a = (props.value || props.defaultValue)) === null || _a === void 0 ? void 0 : _a.toString().length) || 0;
        const onChangeHandler = (event) => {
            const target = event.target;
            if (characterCount) {
                characterCount.value = target.value.length;
            }
            if (props.onChange) {
                props.onChange(event);
            }
        };
        return { onChangeHandler, valid, shouldValidate, describedById };
    }
});

const _hoisted_1 = ["id", "disabled", "required", "value", "defaulValue", "aria-describedby", "aria-required", "aria-invalid"];

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Label = resolveComponent("Label");

  return (openBlock(), createElementBlock("div", {
    class: normalizeClass([
      `${_ctx.prefix}text-area`,
      {
        [`${_ctx.prefix}text-area--disabled`]: _ctx.disabled,
        [`${_ctx.prefix}text-area--error`]: _ctx.shouldValidate && !_ctx.valid,
        [`${_ctx.prefix}text-area--success`]: _ctx.shouldValidate && _ctx.valid
      },
      `${_ctx.prefix}label-wrapper ${_ctx.prefix}label-wrapper--text-input`
    ])
  }, [
    (_ctx.label)
      ? (openBlock(), createBlock(_component_Label, {
          key: 0,
          title: _ctx.label,
          prefix: _ctx.prefix,
          "html-for": _ctx.id,
          label: _ctx.label
        }, null, 8 /* PROPS */, ["title", "prefix", "html-for", "label"]))
      : createCommentVNode("v-if", true),
    createElementVNode("div", {
      class: normalizeClass(`${_ctx.prefix}text-area__wrapper`)
    }, [
      createElementVNode("textarea", mergeProps({
        id: _ctx.id,
        disabled: _ctx.disabled,
        required: Boolean(_ctx.req)
      }, _ctx.$attrs, {
        value: _ctx.value,
        defaulValue: _ctx.defaultValue,
        "aria-describedby": _ctx.describedById,
        "aria-required": Boolean(_ctx.req),
        "aria-invalid": _ctx.shouldValidate ? !_ctx.valid : undefined,
        onInput: _cache[0] || (_cache[0] = (...args) => (_ctx.onChangeHandler && _ctx.onChangeHandler(...args)))
      }), null, 16 /* FULL_PROPS */, _hoisted_1),
      createElementVNode("span", {
        class: normalizeClass(`${_ctx.prefix}text-area__border`)
      }, null, 2 /* CLASS */)
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}

script.render = render;
script.__file = "packages/vue/text-area/lib/TextArea.vue";

export { script as default };
